/**
 * Helpers de date "aujourd'hui" pour comparaisons et formatage.
 *
 * Pourquoi un helper plutôt que `new Date()` inline :
 *   1. Source unique → si on veut un jour mocker la date courante (tests,
 *      mode démo, replay), on n'a qu'un seul point à remplacer.
 *   2. Évite le piège du `const TODAY = new Date()` exporté/figé à
 *      l'import du module : la valeur se gèle au démarrage de l'app et
 *      devient fausse si la session reste ouverte plus d'une journée.
 *      Toujours appeler `today()` au moment du calcul.
 */

/** Date+heure au moment de l'appel. */
export function today(): Date {
  return new Date();
}

/** Format ISO YYYY-MM-DD du jour courant (zone locale). */
export function todayIso(): string {
  const d = today();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${m}-${day}`;
}

/**
 * Format ISO YYYY-MM-DD → DD/MM/YY (annee 2 chiffres, compact pour tables).
 * Renvoie "" pour null/undefined/"", et la valeur brute si le parse echoue
 * (champ texte libre qui ne suit pas le format ISO).
 * Source unique de verite pour l'affichage des dates dans les tableaux — voir
 * decision user 2026-05-20 (consistance entre DATE ELS, FIN CONTRAT, etc.).
 */
export function formatDateShort(iso: string | null | undefined): string {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  if (!y || !m || !d) return iso;
  return `${d}/${m}/${y.slice(-2)}`;
}
